<div class="card dialog-box">
  <div class="card-header">
    {{ showCloseIcon ? "Switch" : "Select" }} Account
    @if (showCloseIcon) {
      <span class="float-end" (click)="onCloseDialogue()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    }
  </div>

  @if (userLinkedAccounts?.length > 0) {
    <div
      class="d-flex flex-wrap gap-2 justify-content-center mb-2 mb-lg-3 py-2 overflow-y-auto"
      style="max-height: 60vh"
    >
      @for (account of userLinkedAccounts; track account) {
        <div
          (click)="
            userData?.subscriber?.subscriber_user_id !== account?.sub_user_id ||
            !showCloseIcon
              ? onCloseDialogue(account)
              : null
          "
          [attr.role]="
            userData?.subscriber?.subscriber_user_id !== account?.sub_user_id ||
            !showCloseIcon
              ? 'button'
              : null
          "
          class="px-4 py-2 text-dark rounded col-12 col-lg-5"
          [class.hover]="
            userData?.subscriber?.subscriber_user_id !== account?.sub_user_id ||
            !showCloseIcon
          "
          [ngClass]="
            userData?.subscriber?.subscriber_user_id === account?.sub_user_id &&
            showCloseIcon
              ? 'border bg-success-subtle border-success border-2'
              : 'bg-secondary-subtle'
          "
        >
          <div class="d-flex align-items-center">
            <div class="fs-5">{{ account?.name }}</div>
            @if (
              userData?.subscriber?.subscriber_user_id ===
                account?.sub_user_id && showCloseIcon
            ) {
              <div class="ms-2 active-badge bg-success text-white">Active</div>
            }
          </div>

          <div>
            {{ account?.user_name }}
          </div>
          <div>
            {{ account?.email }}
          </div>
        </div>
      }
      <div
        (click)="openAddAccountTemplate()"
        role="button"
        class="hover bg-secondary-subtle p-3 border-primary text-dark d-flex align-items-center gap-3 rounded col-lg-5"
      >
        <div id="add-account-button">
          <i class="fa-solid fa-user-plus"></i>
        </div>

        <div>
          <div class="fs-6">Add Account</div>
        </div>
      </div>
    </div>
    <div class="m-auto">
      <button
        class="btn btn-danger btn-md"
        (click)="onCloseDialogue('fullSignOut')"
      >
        Sign Out of All Accounts
      </button>
    </div>
  }
</div>
<ng-template #addAccountTemplate let-addAccountTemplateRef="dialogRef">
  <div class="card dialog-box">
    <div class="card-header">
      Add Account
      <span class="float-end" (click)="addAccountTemplateRef.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    <div class="p-2 mb-1">
      Sign in with multiple accounts on this device and switch between them with
      ease.
    </div>
    <div class="p-2 mb-3">Start by entering the username and tapping next.</div>
    <div class="mb-2">
      @if (displayMessage) {
        <div class="alert alert-primary" role="alert">
          {{ displayMessage }}
        </div>
      }
      <gtapp-user-login
        (emitData)="emitLoggedInData($event)"
        [blackListedEmails]="alreadyExistingEmails"
      >
      </gtapp-user-login>
    </div>
  </div>
</ng-template>
